import styled from 'styled-components';
export const GnbLayout = styled.nav.withConfig({
  componentId: "sc-1j77bw-0"
})(["&{", " display:", ";grid-template-columns:1fr 3fr 1fr;height:var(--height-global-nav);background-color:hsl(var(--nav));border-bottom:1px solid hsl(var(--nav-border));}"], {
  "zIndex": "20",
  "width": "100%",
  "alignItems": "center",
  "justifyContent": "space-between",
  "paddingLeft": "1.5rem",
  "paddingRight": "1.5rem"
}, props => props.display ? props.display : 'flex');
export const GnbMainLogoWrapper = styled.div.withConfig({
  componentId: "sc-1j77bw-1"
})(["&{", " .object-container{width:11.125rem;position:relative;a{display:block;position:absolute;width:100%;height:100%;z-index:5;top:0px;left:0px;}object{width:100%;}}}"], {
  "marginRight": "3rem",
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "flex-start",
  "gap": "3rem"
});
export const GnbMenuItemContainer = styled.ul.withConfig({
  componentId: "sc-1j77bw-2"
})(["&{", " gap:", ";flex:1;justify-content:", ";> a{", " &:hover{color:hsl(var(--nav-accent-foreground));svg{stroke:hsl(var(--nav-accent-foreground));}}&.picked{", " svg{stroke:hsl(var(--nav-accent-foreground));}}}}"], {
  "margin": "0px",
  "display": "flex"
}, props => props.gap ? props.gap : '1.5rem', props => props.justifyContent ? props.justifyContent : 'start', {
  "display": "flex",
  "alignItems": "center",
  "gap": "0.5rem",
  "paddingLeft": "0.625rem",
  "paddingRight": "0.625rem",
  "paddingTop": "1.25rem",
  "paddingBottom": "1.25rem",
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem",
  "letterSpacing": "0em",
  "fontWeight": "600",
  "color": "hsl(var(--nav-foreground))"
}, {
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem",
  "letterSpacing": "0em",
  "fontWeight": "600",
  "color": "hsl(var(--nav-accent-foreground))"
});
export const GnbUserInfoSection = styled.div.withConfig({
  componentId: "sc-1j77bw-3"
})(["&{", " >button{", "}}"], {
  "position": "relative",
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "flex-end",
  "gap": "1rem"
}, {
  "display": "flex"
});
export const StudentListDropDownContainer = styled.div.withConfig({
  componentId: "sc-1j77bw-4"
})(["&{", " p{", "}}"], {
  "display": "flex",
  "cursor": "pointer",
  "alignItems": "center",
  "gap": "0.5rem"
}, {
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem",
  "letterSpacing": "0em",
  "fontWeight": "600",
  "color": "hsl(var(--nav-accent-foreground))"
});